// extracted by mini-css-extract-plugin
export default {"LoadError":"bfp_a bib_qs bib_a bib_w bib_j bib_q","LoadError__icon":"bfp_b bib_vl bib_fm bib_sw","LoadError__message":"bfp_c bib_fm bib_tr"};